import { GlobalErrorAction } from './actions';

export const globalErrorReducer = (
  state = false,
  { type }: { type: GlobalErrorAction }
) => {
  switch (type) {
    case GlobalErrorAction.THROW_GLOBAL_ERROR:
      return true;
    default:
      return state;
  }
};
